// extracted by mini-css-extract-plugin
export default {"experience":"Experience_experience__C4MiH","experienceCard":"Experience_experienceCard__lyS7S"};